import Component from './BrowseRoutes.component';
import { connect } from 'react-redux';

const mapStateToProps = () => {
    return {};
};

export default connect(mapStateToProps, {})(Component);
